module.exports = __webpack_public_path__ + "img/pot-shadow.5dac878c.webp";